import type { FundDividend } from '@festina/unitlink-general-types/unitlink'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikDoubleInput,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const FundDividendFields = ({ fieldNamePrefix }: Props) => {
  const translate = useTranslate()

  const validateKey =
    typeUtils.createNestedValidator<FundDividend>(fieldNamePrefix)

  return (
    <>
      <FormikDatePicker
        name={validateKey('date')}
        label={translate('funds.fundDividend.date')}
      />
      <FormikDoubleInput
        name={validateKey('amount')}
        label={translate('funds.fundDividend.amount')}
      />
    </>
  )
}
